export enum Category {
    EXCELADDIN = 'Excel Add-in',
}

export enum Action {
    CREATE = 'Create',
    DELETE = 'Delete',
    UPDATE = 'Update',
    DUPLICATE = 'Duplicate',
    RENDER = 'Render',
    SAVE = 'Save',
    CANCEL = 'Cancel',
    EDIT = 'Edit',
    OK = 'ok',
    ADDROW = 'Add row',
    ADDSECTION = 'Add section',
    ADDLEVEL = 'Add level',
    SEARCH = 'Search',
    FORMATSTYLE = 'Format Style',
    CLOSE = 'Close',
    OPEN = 'Open',
    ADDFILTER = 'Add Filter',
    SAVEDOWNLOADVERSION = 'Save Download Version',
    SAVELAUNCHVERSION = 'Save Report Version',
    EDITTEMPLATENAME = 'Edit Template Name',
    BACK = 'Back',
    CANCELDELETE ='Cancel Delete',
    SAVEFLOWCHART = 'Save Flowchart',
    DELETEROW = 'Delete Row',
    EDITMEDIAHIERARCHYNAME = 'Edit Media Hierarchy Name',
}
export enum Module {
    CALENDAR = 'Calendar',
    CALENDAROVERLAY = 'Calendar Overlay',
    HEADER = 'Header',
    INFLIGHTOVERLAY = 'Inflight Overlay',
    MEDIAHIERARCHY = 'Media Hierarchy',
    GRANDTOTALS = 'Grand Totals',
    RIGHTHANDTOTALS = 'Right Hand Totals',
    FOOTER = 'Footer',
    RUNCONFIGURATION = 'Run Configuration',
    FLOWCHART = 'Flowchart',
    REPORT = 'Report',
    THEME = 'Theme',
    RUNRESTRICTION = 'Run Restriction',
}
export enum SubModule {
    HEADER = 'Header',
    LOGO = 'Logo',
    DETAIL = 'Detail',
    SUBTOTALS = 'Sub Total',
    SUBLEVELS = 'Sub Level',
    DELETE = 'Delete Modal',
    CREATE = 'Create Modal',
    RIGHTHANDTOTAL = 'Right Hand Totals',
    GRANDTOTAL = 'Grand Totals',
    THEME ='Theme',
    ADDCALENDARROW = 'Add Row',
    ADDCALENDAROVERLAYSECTION = 'Add Section',
    ADDCALENDAROVERLAYROW = 'Add Row',
    REMOVECALENDAROVERLAYROW = 'Remove Row',
    REMOVECALENDAROVERLAYSECTION = 'Remove Section',
    ADDMEDIAHIERARCHYLEVEL = 'Add Level',
}